import { Conflict } from './conflict'
import { Warning } from './warning'

const ConcurrentEditingWarning = ({ drafts, withMargin }) => (
  <Warning
    type='concurrent'
    title='Other users have drafts on this page'
    data={drafts}
    withMargin={withMargin}
  />
)

const OutdatedWarning = ({ drafts, withMargin }) => (
  <Warning
    type='outdated'
    title='There is more recent version of this page published by another user'
    data={[ drafts ]}
    withMargin={withMargin}
  />
)

const ConflictWarning = ({ data, withMargin, resolve }) => (
  <Conflict
    data={data}
    withMargin={withMargin}
    resolve={resolve}
  />
)

export function RenderWarning ({ withMargin, resolve, pageData }) {
  const currentUserDraft = pageData.metadata?.drafts?.find(
    d => d.id === pageData.user.id
  )

  const outdatedWarning =
    currentUserDraft?.created &&
    new Date(pageData.metadata.current?.created) >
      new Date(currentUserDraft?.created)

  const concurrentEditing =
    pageData.metadata?.drafts?.filter(d => d.id !== pageData.user.id).length >
    0

  const otherUserDrafts = pageData.metadata?.drafts?.filter(
    d => d.id !== pageData.user.id
  )

  const { conflicts } = pageData

  return (
    <>
      {concurrentEditing && (
        <ConcurrentEditingWarning
          key='concurrentEditing'
          drafts={otherUserDrafts}
          withMargin={withMargin}
        />
      )}
      {outdatedWarning && (
        <OutdatedWarning
          key='outdatedWarning'
          drafts={pageData.metadata.current}
          withMargin={withMargin}
        />
      )}
      {conflicts && (
        <ConflictWarning
          key='conflicts'
          data={pageData.conflicts}
          withMargin={withMargin}
          resolve={resolve}
        />
      )}
    </>
  )
}

export default RenderWarning
